// Image Gallery
const mainImages = document.querySelectorAll(".main-image");
const thumbnailWrappers = document.querySelectorAll(".thumbnail-dot-wrapper");
const thumbnailScroll = document.querySelector(".thumbnail-scroll");
const prevButton = document.querySelector(".thumbnail-nav.prev");
const nextButton = document.querySelector(".thumbnail-nav.next");
const thumbnailWrapper = document.querySelector(".thumbnail-wrapper");

let currentScrollPosition = 0;
const thumbnailHeight = 115; // thumbnail height + gap
let isMobile = window.innerWidth <= 768;

// Function to update navigation buttons visibility
function updateNavButtons() {
  if (isMobile) return; // Don't show nav buttons on mobile

  const maxScroll =
    thumbnailScroll.scrollHeight - thumbnailWrapper.clientHeight;
  prevButton.classList.toggle("hidden", currentScrollPosition <= 0);
  nextButton.classList.toggle("hidden", currentScrollPosition >= maxScroll);
}

// Function to handle window resize
function handleResize() {
  const wasMobile = isMobile;
  isMobile = window.innerWidth <= 768;

  // Reset transforms and scroll when switching between mobile and desktop
  if (wasMobile !== isMobile) {
    currentScrollPosition = 0;
    thumbnailScroll.style.transform = "";
    if (!isMobile) {
      updateNavButtons();
    }
  }
}

// Initialize
updateNavButtons();
window.addEventListener("resize", handleResize);

// Swipe functionality
let touchStartX = 0;
let touchEndX = 0;
let touchStartY = 0;
let touchEndY = 0;
const swipeThreshold = 50; // minimum distance for a swipe
const mainImageContainer = document.querySelector(".main-image-container");

function getCurrentImageIndex() {
  let currentIndex = 0;
  mainImages.forEach((img, index) => {
    if (!img.classList.contains("hidden")) {
      currentIndex = index;
    }
  });
  return currentIndex;
}

function showImageByIndex(index) {
  if (index < 0 || index >= mainImages.length) return;

  const targetImage = mainImages[index];
  const mediaId = targetImage.getAttribute("data-media-id");

  // Hide all images and show the target one
  mainImages.forEach((img) => {
    if (img === targetImage) {
      img.classList.remove("hidden");

      // Load full resolution if not already loaded
      if (img.getAttribute("data-loaded") === "false") {
        const fullSrc = img.getAttribute("data-full-src");
        img.src = fullSrc;
        img.setAttribute("data-loaded", "true");
      }
    } else {
      img.classList.add("hidden");
    }
  });

  // Update active thumbnail
  thumbnailWrappers.forEach((wrapper) => {
    if (wrapper.getAttribute("data-media-id") === mediaId) {
      wrapper.classList.add("active");
    } else {
      wrapper.classList.remove("active");
    }
  });

  // Scroll thumbnail into view if needed
  const activeThumbnail = document.querySelector(
    `.thumbnail-dot-wrapper[data-media-id="${mediaId}"]`
  );
  if (activeThumbnail) {
    if (isMobile) {
      activeThumbnail.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    } else {
      // Update vertical scroll position for desktop
      const thumbnailIndex =
        Array.from(thumbnailWrappers).indexOf(activeThumbnail);
      const visibleThumbnails = Math.floor(
        thumbnailWrapper.clientHeight / thumbnailHeight
      );

      if (thumbnailIndex < currentScrollPosition / thumbnailHeight) {
        // Scroll up
        currentScrollPosition = thumbnailIndex * thumbnailHeight;
        thumbnailScroll.style.transform = `translateY(-${currentScrollPosition}px)`;
      } else if (
        thumbnailIndex >=
        currentScrollPosition / thumbnailHeight + visibleThumbnails
      ) {
        // Scroll down
        currentScrollPosition =
          (thumbnailIndex - visibleThumbnails + 1) * thumbnailHeight;
        thumbnailScroll.style.transform = `translateY(-${currentScrollPosition}px)`;
      }
      updateNavButtons();
    }
  }
}

function handleSwipe() {
  const deltaX = touchEndX - touchStartX;
  const deltaY = touchEndY - touchStartY;

  // Check if it's a horizontal swipe (more horizontal than vertical)
  if (
    Math.abs(deltaX) > Math.abs(deltaY) &&
    Math.abs(deltaX) > swipeThreshold
  ) {
    const currentIndex = getCurrentImageIndex();

    if (deltaX > 0) {
      // Swipe right - show previous image
      showImageByIndex(currentIndex - 1);
    } else {
      // Swipe left - show next image
      showImageByIndex(currentIndex + 1);
    }
  }
}

// Touch event listeners for swipe
if (mainImageContainer) {
  mainImageContainer.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    },
    { passive: true }
  );

  mainImageContainer.addEventListener(
    "touchend",
    (e) => {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    },
    { passive: true }
  );

  // Mouse events for desktop swipe (click and drag)
  let isMouseDown = false;
  let mouseStartX = 0;
  let mouseStartY = 0;

  mainImageContainer.addEventListener("mousedown", (e) => {
    isMouseDown = true;
    mouseStartX = e.screenX;
    mouseStartY = e.screenY;
    mainImageContainer.style.cursor = "grabbing";
  });

  mainImageContainer.addEventListener("mousemove", (e) => {
    if (isMouseDown) {
      e.preventDefault();
    }
  });

  mainImageContainer.addEventListener("mouseup", (e) => {
    if (isMouseDown) {
      const deltaX = e.screenX - mouseStartX;
      const deltaY = e.screenY - mouseStartY;

      // Check if it's a horizontal swipe
      if (
        Math.abs(deltaX) > Math.abs(deltaY) &&
        Math.abs(deltaX) > swipeThreshold
      ) {
        const currentIndex = getCurrentImageIndex();

        if (deltaX > 0) {
          showImageByIndex(currentIndex - 1);
        } else {
          showImageByIndex(currentIndex + 1);
        }
      }

      isMouseDown = false;
      mainImageContainer.style.cursor = "grab";
    }
  });

  mainImageContainer.addEventListener("mouseleave", () => {
    isMouseDown = false;
    mainImageContainer.style.cursor = "grab";
  });

  // Set initial cursor
  mainImageContainer.style.cursor = "grab";
}

// Keyboard navigation (arrow keys)
document.addEventListener("keydown", (e) => {
  if (e.key === "ArrowLeft") {
    const currentIndex = getCurrentImageIndex();
    showImageByIndex(currentIndex - 1);
  } else if (e.key === "ArrowRight") {
    const currentIndex = getCurrentImageIndex();
    showImageByIndex(currentIndex + 1);
  }
});

// Thumbnail click handler
thumbnailWrappers.forEach((wrapper) => {
  wrapper.addEventListener("click", () => {
    const mediaId = wrapper.getAttribute("data-media-id");

    // Hide all images and show the selected one
    mainImages.forEach((img) => {
      if (img.getAttribute("data-media-id") === mediaId) {
        img.classList.remove("hidden");

        // Load full resolution if not already loaded
        if (img.getAttribute("data-loaded") === "false") {
          const fullSrc = img.getAttribute("data-full-src");
          img.src = fullSrc;
          img.setAttribute("data-loaded", "true");
        }
      } else {
        img.classList.add("hidden");
      }
    });

    // Update active thumbnail
    thumbnailWrappers.forEach((w) => w.classList.remove("active"));
    wrapper.classList.add("active");

    // Scroll thumbnail into view on mobile
    if (isMobile) {
      wrapper.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  });
});

// Navigation button click handlers (desktop only)
prevButton &&
  prevButton.addEventListener("click", () => {
    if (isMobile) return;
    currentScrollPosition = Math.max(
      0,
      currentScrollPosition - thumbnailHeight
    );
    thumbnailScroll.style.transform = `translateY(-${currentScrollPosition}px)`;
    updateNavButtons();
  });

nextButton &&
  nextButton.addEventListener("click", () => {
    if (isMobile) return;
    const maxScroll =
      thumbnailScroll.scrollHeight - thumbnailWrapper.clientHeight;
    currentScrollPosition = Math.min(
      maxScroll,
      currentScrollPosition + thumbnailHeight
    );
    thumbnailScroll.style.transform = `translateY(-${currentScrollPosition}px)`;
    updateNavButtons();
  });

// Variant Selector with Price and Image Update
const variantIdInput = document.getElementById("variant-id");
const addToCartBtn = document.getElementById("add-to-cart-btn");
const productData = window.productVariants || [];
const selectedOptions = {};

// Initialize with first available variant
if (productData && productData.length > 0) {
  const firstVariantData = productData[0];
  firstVariantData.options.forEach((option, index) => {
    selectedOptions[`option${index + 1}`] = option;
  });
}

// Function to find variant based on selected options
function findVariantByOptions(options) {
  const variant = productData.find((variant) => {
    const match = Object.keys(options).every((key) => {
      return variant[key] === options[key];
    });
    return match;
  });

  return variant;
}

// Function to update variant
function updateSelectedVariant() {
  const variant = findVariantByOptions(selectedOptions);

  if (variant) {
    // Update hidden input with selected variant ID
    variantIdInput.value = variant.id;

    // Update add to cart button state
    const buttonText = addToCartBtn.querySelector("span");
    if (variant.available) {
      addToCartBtn.disabled = false;
      addToCartBtn.removeAttribute("disabled");
      // Format price with currency
      const formattedPrice = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: window.cartCurrency || "GBP",
      }).format(variant.price / 100);
      if (buttonText)
        buttonText.innerHTML = `<span class="button-text">ADD TO BASKET</span> | <span class="button-price">${formattedPrice}</span>`;
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.setAttribute("disabled", "disabled");
      if (buttonText) buttonText.textContent = "SOLD OUT";
    }

    // Switch main image if variant has a featured image
    if (variant.featured_media && variant.featured_media.id) {
      const mediaId = variant.featured_media.id.toString();

      // Hide all images and show the variant's image
      mainImages.forEach((img) => {
        if (img.getAttribute("data-media-id") === mediaId) {
          img.classList.remove("hidden");

          // Load full resolution if not already loaded
          if (img.getAttribute("data-loaded") === "false") {
            const fullSrc = img.getAttribute("data-full-src");
            img.src = fullSrc;
            img.setAttribute("data-loaded", "true");
          }
        } else {
          img.classList.add("hidden");
        }
      });

      // Update active thumbnail
      const thumbnailWithImage = document.querySelector(
        `.thumbnail-dot-wrapper[data-media-id="${mediaId}"]`
      );
      if (thumbnailWithImage) {
        thumbnailWrappers.forEach((w) => w.classList.remove("active"));
        thumbnailWithImage.classList.add("active");

        // Scroll thumbnail to first position on desktop
        if (!isMobile && thumbnailScroll && thumbnailWrapper) {
          const thumbnailIndex =
            Array.from(thumbnailWrappers).indexOf(thumbnailWithImage);

          // Always scroll to make the selected thumbnail the first visible item
          currentScrollPosition = thumbnailIndex * thumbnailHeight;
          thumbnailScroll.style.transform = `translateY(-${currentScrollPosition}px)`;
          updateNavButtons();
        }
      }

      // Slide mobile carousel to the corresponding image
      if (emblaApi && window.innerWidth <= 768) {
        // Find the index of the slide with matching media-id
        const emblaSlides = document.querySelectorAll(".embla__slide");
        let targetIndex = 0;

        emblaSlides.forEach((slide, index) => {
          // Check data-media-id on the slide container first
          const slideMediaId = slide.getAttribute("data-media-id");

          // Also check the image element as backup
          const slideImg = slide.querySelector(".embla__slide__img");
          const imgMediaId = slideImg
            ? slideImg.getAttribute("data-media-id")
            : null;

          // Match based on data-media-id attribute (try slide first, then img)
          if (slideMediaId === mediaId || imgMediaId === mediaId) {
            targetIndex = index;
          }
        });

        // Scroll to the target slide
        emblaApi.scrollTo(targetIndex);
      }
    }
  } else {
    console.error("No variant found for options:", selectedOptions);
  }
}

// Handle color swatch clicks
const colorSwatches = document.querySelectorAll(".color-swatch");

colorSwatches.forEach((swatch) => {
  swatch.addEventListener("click", (e) => {
    e.preventDefault();

    const optionValue = swatch.getAttribute("data-option-value");
    const optionPosition = parseInt(
      swatch.getAttribute("data-option-position")
    );
    const strokeSrc = swatch.getAttribute("data-stroke-src");

    // Remove selected class from siblings
    const container = swatch.closest(".color-swatch-container");
    container
      .querySelectorAll(".color-swatch")
      .forEach((s) => s.classList.remove("selected"));
    swatch.classList.add("selected");

    // Update selected option value text in label
    const optionGroup = swatch.closest(".variant-option-group");
    const selectedValueSpan = optionGroup?.querySelector(
      ".selected-option-value"
    );
    const selectedStrokeSpan = optionGroup?.querySelector(
      ".selected-option-stroke"
    );
    if (selectedValueSpan) {
      selectedValueSpan.textContent = optionValue;
    }
    if (selectedStrokeSpan) {
      selectedStrokeSpan.src = strokeSrc;
    }

    // Update selected options
    selectedOptions[`option${optionPosition}`] = optionValue;
    updateSelectedVariant();
  });
});

// Handle other variant option clicks
const variantOptions = document.querySelectorAll(".variant-option");

variantOptions.forEach((option) => {
  option.addEventListener("click", (e) => {
    e.preventDefault();

    const optionValue = option.getAttribute("data-option-value");
    const optionPosition = parseInt(
      option.getAttribute("data-option-position")
    );
    const strokeSrc = swatch.getAttribute("data-stroke-src");

    // Remove selected class from siblings
    const container = option.closest(".variant-selector");
    container
      .querySelectorAll(".variant-option")
      .forEach((o) => o.classList.remove("selected"));
    option.classList.add("selected");

    // Update selected option value text in label
    const optionGroup = option.closest(".variant-option-group");
    const selectedValueSpan = optionGroup?.querySelector(
      ".selected-option-value"
    );
    if (selectedValueSpan) {
      selectedValueSpan.textContent = optionValue;
    }
    if (selectedStrokeSpan) {
      selectedStrokeSpan.src = strokeSrc;
    }

    // Update selected options
    selectedOptions[`option${optionPosition}`] = optionValue;
    updateSelectedVariant();
  });
});

// Quantity Selector
const quantityInput = document.querySelector(".quantity-input");
const minusBtn = document.querySelector(".minus");
const plusBtn = document.querySelector(".plus");

minusBtn.addEventListener("click", () => {
  const currentValue = parseInt(quantityInput.value);
  if (currentValue > 1) {
    quantityInput.value = currentValue - 1;
  }
});

plusBtn.addEventListener("click", () => {
  const currentValue = parseInt(quantityInput.value);
  quantityInput.value = currentValue + 1;
});

// Collapsible Sections
const collapsibleHeaders = document.querySelectorAll(".collapsible-header");

collapsibleHeaders.forEach((header) => {
  header.addEventListener("click", () => {
    const content = header.nextElementSibling;

    // Toggle header active state
    header.classList.toggle("active");

    // Toggle content visibility with smooth animation
    if (content.classList.contains("active")) {
      content.style.maxHeight = "0";
      content.classList.remove("active");

      // Allow time for the animation to complete
      setTimeout(() => {
        content.style.padding = "0 16px";
      }, 300);
    } else {
      content.classList.add("active");
      content.style.maxHeight = content.scrollHeight + 40 + "px"; // Add padding to height
      content.style.padding = "0 16px 16px";
    }

    // Close other sections
    const parentSection = header.closest(".collapsible-section");
    const allSections = document.querySelectorAll(".collapsible-section");

    allSections.forEach((section) => {
      if (section !== parentSection) {
        const otherHeader = section.querySelector(".collapsible-header");
        const otherContent = section.querySelector(".collapsible-content");

        if (otherContent.classList.contains("active")) {
          otherHeader.classList.remove("active");
          otherContent.style.maxHeight = "0";
          otherContent.classList.remove("active");

          setTimeout(() => {
            otherContent.style.padding = "0 16px";
          }, 300);
        }
      }
    });
  });
});

// Mobile Slider with Embla Carousel
let emblaApi = null; // Make emblaApi globally accessible

if (window.innerWidth <= 768 && typeof EmblaCarousel !== "undefined") {
  const emblaNode = document.querySelector(".embla");
  const dotsNode = document.querySelector(".embla__dots");

  if (emblaNode) {
    emblaApi = EmblaCarousel(emblaNode, {
      loop: false,
      align: "start",
      containScroll: "trimSnaps",
      dragFree: false,
    });

    // Load image function
    const loadImage = (img) => {
      if (img.classList.contains("loaded")) return;

      const highResSrc = img.getAttribute("data-src");
      if (highResSrc) {
        const highResImage = new Image();
        highResImage.onload = () => {
          img.src = highResSrc;
          img.classList.add("loaded");
        };
        highResImage.src = highResSrc;
      }
    };

    // Load first image immediately
    const firstImage = emblaNode.querySelector(".embla__slide__img");
    if (firstImage) {
      loadImage(firstImage);
    }

    // Load images on slide change (load current and next slide)
    const loadVisibleImages = () => {
      const currentIndex = emblaApi.selectedScrollSnap();
      const slides = emblaApi.slideNodes();

      // Load current slide image
      const currentSlideImg =
        slides[currentIndex]?.querySelector(".lazy-image");
      if (currentSlideImg) {
        loadImage(currentSlideImg);
      }

      // Preload next slide image
      const nextSlideImg =
        slides[currentIndex + 1]?.querySelector(".lazy-image");
      if (nextSlideImg) {
        loadImage(nextSlideImg);
      }

      // Preload previous slide image
      const prevSlideImg =
        slides[currentIndex - 1]?.querySelector(".lazy-image");
      if (prevSlideImg) {
        loadImage(prevSlideImg);
      }
    };

    // Create dots
    const slides = emblaApi.slideNodes();
    const dots = [];

    slides.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.className = "embla__dot";
      dot.type = "button";
      dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
      dot.addEventListener("click", () => emblaApi.scrollTo(index));
      dotsNode.appendChild(dot);
      dots.push(dot);
    });

    // Update dots on slide change
    const updateDots = () => {
      const selectedIndex = emblaApi.selectedScrollSnap();
      dots.forEach((dot, index) => {
        if (index === selectedIndex) {
          dot.classList.add("is-selected");
          dot.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        } else {
          dot.classList.remove("is-selected");
        }
      });
    };

    emblaApi.on("select", () => {
      updateDots();
      loadVisibleImages();
    });

    emblaApi.on("init", () => {
      updateDots();
      loadVisibleImages();
    });

    updateDots();
    loadVisibleImages();
  }
}

// Ritual Banner Smooth Scroll
const ritualBanner = document.getElementById("ritual-banner");
const psaSection = document.querySelector(".psa-curly-metafield-parent");

if (ritualBanner && psaSection) {
  // Add cursor pointer style
  ritualBanner.style.cursor = "pointer";

  // Function to handle scroll with offset for sticky header
  const scrollToPsaSection = () => {
    // Get header height (check for sticky header)
    const header =
      document.querySelector(".section-header") ||
      document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;

    // Add extra offset (adjust this value as needed - typically 20-40px for breathing room)
    const extraOffset = 20;
    const totalOffset = headerHeight + extraOffset;

    // Get the position of the PSA section
    const psaSectionTop =
      psaSection.getBoundingClientRect().top + window.pageYOffset;

    // Scroll to position minus the offset
    window.scrollTo({
      top: psaSectionTop - totalOffset,
      behavior: "smooth",
    });
  };

  // Click event
  ritualBanner.addEventListener("click", scrollToPsaSection);

  // Keyboard accessibility (Enter or Space)
  ritualBanner.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      scrollToPsaSection();
    }
  });
}

const reviewCountLink = document.getElementById("review-count-link");
const reviewsSection = document.getElementById(
  "opinew-reviews-product-page-code"
);

if (reviewCountLink && reviewsSection) {
  const scrollToReviewsSection = () => {
    const header =
      document.querySelector(".section-header") ||
      document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;

    const extraOffset = 20;
    const totalOffset = headerHeight + extraOffset;

    const reviewsSectionTop =
      reviewsSection.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: reviewsSectionTop - totalOffset,
      behavior: "smooth",
    });
  };

  reviewCountLink.addEventListener("click", scrollToReviewsSection);

  reviewCountLink.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      scrollToReviewsSection();
    }
  });
}

// Offer Slider
const offerSliderTrack = document.querySelector(".offer-slider-track");
const offerCards = document.querySelectorAll(".offer-card");
const offerPrevBtn = document.querySelector(".offer-nav-btn.prev");
const offerNextBtn = document.querySelector(".offer-nav-btn.next");

if (offerSliderTrack && offerCards.length > 0 && offerPrevBtn && offerNextBtn) {
  let currentOfferIndex = 0;
  const totalOffers = offerCards.length;

  // Function to update slider position
  function updateOfferSlider() {
    const cardWidth = offerCards[0].offsetWidth;
    const gap = 16; // Match the gap in CSS
    const translateX = -(currentOfferIndex * (cardWidth + gap));
    offerSliderTrack.style.transform = `translateX(${translateX}px)`;

    // Update button states
    offerPrevBtn.disabled = currentOfferIndex === 0;
    offerNextBtn.disabled = currentOfferIndex === totalOffers - 1;
  }

  // Previous button click
  offerPrevBtn.addEventListener("click", () => {
    if (currentOfferIndex > 0) {
      currentOfferIndex--;
      updateOfferSlider();
    }
  });

  // Next button click
  offerNextBtn.addEventListener("click", () => {
    if (currentOfferIndex < totalOffers - 1) {
      currentOfferIndex++;
      updateOfferSlider();
    }
  });

  // Handle window resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateOfferSlider();
    }, 100);
  });

  // Touch/swipe support for mobile
  let offerTouchStartX = 0;
  let offerTouchEndX = 0;
  const offerSliderContainer = document.querySelector(
    ".offer-slider-container"
  );

  if (offerSliderContainer) {
    offerSliderContainer.addEventListener(
      "touchstart",
      (e) => {
        offerTouchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );

    offerSliderContainer.addEventListener(
      "touchend",
      (e) => {
        offerTouchEndX = e.changedTouches[0].screenX;
        handleOfferSwipe();
      },
      { passive: true }
    );

    function handleOfferSwipe() {
      const swipeThreshold = 50;
      const swipeDistance = offerTouchEndX - offerTouchStartX;

      if (Math.abs(swipeDistance) > swipeThreshold) {
        if (swipeDistance > 0 && currentOfferIndex > 0) {
          // Swipe right - previous
          currentOfferIndex--;
          updateOfferSlider();
        } else if (swipeDistance < 0 && currentOfferIndex < totalOffers - 1) {
          // Swipe left - next
          currentOfferIndex++;
          updateOfferSlider();
        }
      }
    }
  }

  // Initialize slider
  updateOfferSlider();
}

dev_selected - option - stroke;
